var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.type === "ppt"
      ? _c(
          "div",
          { staticClass: "toggle-wrapper" },
          [
            _c("div", { staticClass: "progress-wrapper" }, [
              _c("span", { on: { click: _vm.toggleDisplayHandler } }, [
                _vm._v(_vm._s(_vm.toggleDisplayControllText))
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.finishedNum) + "/" + _vm._s(_vm.totalNum))
              ])
            ]),
            _vm._v(" "),
            _c("el-progress", {
              staticClass: "progress-content",
              attrs: {
                percentage: _vm.finishedPercent,
                "stroke-width": 12,
                "show-text": false,
                color: "#68BF7B"
              }
            }),
            _vm._v(" "),
            _vm.showUploadDisplayStyle === "oneByOne"
              ? _c("div", { staticClass: "checkout-wrapper" }, [
                  _c(
                    "span",
                    {
                      class: { disabled: _vm.preDisabled },
                      on: { click: _vm.preHandler }
                    },
                    [_vm._v("返回上一课时")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      class: { disabled: _vm.nextDisabled },
                      on: { click: _vm.nextHandler }
                    },
                    [_vm._v("下一课时")]
                  )
                ])
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "file-list" },
      _vm._l(_vm.currentUploadFiles, function(materials, pIndex) {
        return _c(
          "div",
          { key: pIndex, class: _vm.fileWrapperDisplayClassName },
          [
            _c("div", { staticClass: "ppt-border" }, [
              _vm.type === "ppt"
                ? _c("div", [
                    _c("p", { staticClass: "course-title" }, [
                      _vm._v("第" + _vm._s(materials.index + 1) + "课时")
                    ]),
                    _vm._v(" "),
                    _vm.shouldShowMaterialTitle
                      ? _c(
                          "div",
                          {
                            staticClass: "file-name-input file-font",
                            attrs: { title: materials.title }
                          },
                          [_vm._v(_vm._s(materials.title))]
                        )
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: materials.title,
                              expression: "materials.title"
                            }
                          ],
                          staticClass: "file-name-input",
                          attrs: {
                            placeholder: materials.placeholder,
                            type: "text"
                          },
                          domProps: { value: materials.title },
                          on: {
                            focus: function($event) {
                              return _vm.inputFous($event, materials)
                            },
                            blur: function($event) {
                              return _vm.inputChange($event, materials)
                            },
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.inputChange($event, materials)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(materials, "title", $event.target.value)
                            }
                          }
                        })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "file-series" },
                [
                  _vm._l(materials.files, function(file, index) {
                    return _c(
                      "div",
                      {
                        key: pIndex + "" + index,
                        staticClass: "upload-view-container",
                        class: { "prevent-style": _vm.showMask(materials) }
                      },
                      [
                        file.updateObjectWhenMaterialRejected(
                          _vm.hidenFileStatus ? "" : materials.auditStatus,
                          materials.rejectedDate,
                          materials.id
                        ).show === "approve"
                          ? _c("div", {
                              staticClass: "upload-musk",
                              on: {
                                click: function($event) {
                                  return _vm.isUpload(file.id)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("upload-view", {
                          ref: "refName" + file.id,
                          refInFor: true,
                          attrs: {
                            type: file.type,
                            fileDesc: _vm.desc,
                            tag: pIndex + "" + index,
                            deleteable: _vm.deleteVisible(materials, file),
                            img: _vm.iconShow(file),
                            icon: file.icon,
                            activeIcon: file.activeIcon,
                            index: index,
                            path: _vm.fileUrl(file),
                            name: file.remoteFile.name,
                            activityId: _vm.activityId,
                            playerId: _vm.playerId,
                            couldDownload:
                              !_vm.deleteVisible(materials, file) &&
                              _vm.canDownload,
                            changeObj: file.updateObjectWhenMaterialRejected(
                              _vm.hidenFileStatus ? "" : materials.auditStatus,
                              materials.rejectedDate,
                              materials.id
                            )
                          },
                          on: {
                            uploadSucc: function($event) {
                              return _vm.uploadSuccessHandler(
                                arguments,
                                file,
                                materials,
                                index
                              )
                            },
                            uploadDel: function($event) {
                              return _vm.deleteFileHandler(file)
                            },
                            deleteFile: function() {
                              return _vm.clickRemove(
                                file,
                                pIndex,
                                index,
                                materials
                              )
                            },
                            download: function() {
                              return _vm.downloadAttachment(file)
                            }
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm.showMask(materials)
                    ? _c("div", { staticClass: "mask" }, [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !materials.title,
                                expression: "!materials.title"
                              }
                            ]
                          },
                          [_vm._v("请先填写教学设计标题")]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: materials.title,
                                expression: "materials.title"
                              }
                            ]
                          },
                          [_vm._v("输入回车保存标题")]
                        )
                      ])
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _vm.showRejetedTxt(materials)
                ? _c("div", {
                    staticClass: "audit-content",
                    domProps: { innerHTML: _vm._s(materials.auditContent) }
                  })
                : _vm._e()
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c96c1336", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c96c1336","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MaterialUploader.vue
// module id = null
// module chunks = 